export default __webpack_public_path__ + "static/media/PPTIcon.ce4ade42.svg";